module.exports = __webpack_public_path__ + "img/logo-mobile.eac72ba8.png";